// Create an individual services object with keys being its router name (defined in router.base)
// List all variables used in that service and create an import that can be loaded when necessary
import { fetchFrontpageService } from '@root/modules/frontpage/services/feed.service';

import { fetchArticle } from '@root/modules/article/services/Article.service';

import { fetchArticleForComments } from '@root/modules/article/services/ArticleForComments.service';

import { fetchCategoryWithHeadlines } from '@root/modules/category/services/CategoryData.service';

import { fetchTagWithHeadlines } from '@root/modules/tags/services/TagWithHeadlines.service';

import { fetchIssues } from '@root/modules/issue/services/Issues.service';

import { fetchIssueWithHeadlines } from '@root/modules/issue/services/IssueWithHeadlines.service';

export default {
  frontpage: {
    variables: ['domain'] as ['domain'],
    service: fetchFrontpageService,
    store: 'frontpage',
  },
  channel: {
    variables: ['domain'] as ['domain'],
    service: fetchFrontpageService,
    store: 'frontpage',
  },
  article: {
    variables: ['id', 'language', 'preview', 'application'] as ['id', 'language', 'preview', 'application'],
    service: fetchArticle,
    store: 'article',
  },
  articleComments: {
    variables: ['id'] as ['id'],
    service: fetchArticleForComments,
    store: 'article',
  },
  category: {
    variables: ['channel', 'domain', 'parent', 'slug', 'language', 'page'] as ['channel', 'domain', 'parent', 'slug', 'language', 'page'],
    service: fetchCategoryWithHeadlines,
    store: 'category',
  },
  topic: {
    variables: ['slug', 'language', 'page', 'tagLanguage'] as ['slug', 'language', 'page', 'tagLanguage'],
    service: fetchTagWithHeadlines,
    store: 'tag',
  },
  issues: {
    variables: ['domain', 'page'] as ['domain', 'page'],
    service: fetchIssues,
    store: 'issue',
  },
  'issue-page': {
    variables: ['id', 'domain'] as ['id', 'domain'],
    service: fetchIssueWithHeadlines,
    store: 'issue',
  },
  'issue-article': {
    variables: ['id', 'domain'] as ['id', 'domain'],
    service: fetchIssueWithHeadlines,
    store: 'issue',
  },
};
